<template>
	<div class="menu">
        <main>
            <div class="list">
                <h2>装车录入</h2>

                <van-field v-model="list.zhuchang" label="猪场" readonly />
                <van-field v-model="list.type" label="运载类别" readonly />
                <van-field v-model="list.danwei" label="运载单位" readonly />
                <van-field v-model="list.chepai" label="车牌" readonly />
                <van-field v-model="list.number" label="定额装载量" readonly />
                <van-field v-model="list.tel" label="电话" readonly />
                <van-field v-model="list.name" label="姓名" readonly />
                <van-field @blur="handleInput1" v-model="flow1" type="number"  label="装前" />
                <van-field @blur="handleInput2" v-model="flow2" type="number"  label="装后" />
                <van-field v-model="now1" label="当期装载量" />
                <van-field v-model="flow3" type="number"  label="出发里程" />
                <van-field v-model="flow4" type="number"  label="结束里程" />
                <van-field v-model="beizhu" label="备注" />

                <h4>业务时间（装车后水印照片上显示的时间）</h4>
                
                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="业务时间"
                    placeholder="点击选择"
                    @click="showPicker = true"
                />

                <van-popup v-model:show="showPicker" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>

                <hr/>                

                <h4>请上传装前照片，装后照片，里程以及整车照片</h4>
                <van-uploader  v-model="fileList" multiple :max-count="6"  :before-read="beforeRead"/>
                <br><br>
                <br><br>
                <van-button type="danger" style="width:100%" @click="sub()">提交</van-button>
            </div>
        </main>
    </div>
</template>

<script>   
    import { url2 } from '../router/api';
	export default{
		data(){
			return{
                fileList: [],
                list:'',
                flow1:'',
                flow2:'',
                flow3:'',
                flow4:'',
                now1:'',   
                loading:'',
                beizhu:'',  
                
                maxDate: new Date(2030, 10, 1),
                currentDate: new Date(),
                showPicker:false,
                time:"",
            }
        },

        mounted() {
            this.list = JSON.parse(this.$route.query.list)
            this.getLicheng()
        },

        watch: {
            flow1(val) {
                this.now1 = this.flow2 - this.flow1;
                this.now1 = this.now1.toFixed('2')
            },
            flow2(val) {
                this.now1 = this.flow2 - this.flow1;
                this.now1 = this.now1.toFixed('2')
            },
        },

		methods: {
            getLicheng() {
                this.axios.get(url2+'searchList', {
                    params:{
                        export:'',
                        chepai:this.list.chepai,
                        zhuchang:'',
                        type:'',
                        time1:'',
                        time2:'',
                        page:1,
                        per_page:50,
                        zhuangtai:'',
                        siji:'',
                    }
                }).then(res=> {
                    if(res.data.data.data[0].info4){
                        this.flow3 = res.data.data.data[0].info4
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },
            onConfirm(value) {
                this.time = this.formatDate(value)
                this.showPicker = false;
            },

            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },

            handleInput1(e) {
                this.flow1 = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            },
            handleInput2(e) {
                this.flow2 = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            },
            beforeRead(file){
               return this.$compress(file)
            },
            onOversize(file) {
                this.$dialog.alert({
                    title: '提示',
                    message: '文件大小不能超过500kb',
                }).then(() => {
                    return;
                });
            },
            sub() {
                if(this.flow1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入装前单位',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入装后单位',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow3=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入里程',
                    }).then(() => {
                        return;
                    });
                } else if(this.flow4=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入里程',
                    }).then(() => {
                        return;
                    });
                }else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入业务时间',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否确定提交',
                    }).then(() => {
                        this.timeTest()
                    }).catch(() => {});
                }
            },

            timeTest() {
                this.axios.get(url2+'searchList', {
                    params:{
                        export:'',
                        chepai:this.list.chepai,
                        zhuchang:'',
                        type:'',
                        time1:'',
                        time2:'',
                        page:'',
                        per_page:'',
                        zhuangtai:'',
                        siji:'',
                    }
                }).then(res=> {
                    var time2 = ''
                    if(res.data.data.data.length>1) {
                        time2 = res.data.data.data[0].time
                    }
                    if(time2) {
                        let t1 = time2.replace(/-/g,'/'); 
                        let t2 = this.time.replace(/-/g,'/');
                        t1 = Date.parse(t1)
                        t2 = Date.parse(t2)
                        let t3 = parseInt(t2 - t1) / 60000 
                        if(t3>=30) {
                            this.sure()
                        } else {
                            this.$dialog.alert({
                                title: '提示',
                                message: '无法提交，业务时间相差不足半小时',
                            }).then(() => {
                                return;
                            });
                        }
                    } else {
                        this.sure()
                    }

                }).catch(err=> {
                    console.log(err);
                });
                   
            },

            sure() {
                var date = new Date(); 
                var day = date.getDate();
                day = day < 10 ? '0' + day : day
                var time2 = this.time.slice(8,10)
                if(day==time2) {
                    if(this.fileList.length<4) {
                        this.$dialog.alert({
                            title: '提示',
                            message: '最少上传四张照片',
                        }).then(() => {
                            return;
                        });
                    } else {
                        this.loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: '加载中',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        var formData =new FormData();
                        var flag = 0
                        this.fileList.map(item=>{
                            formData.append('file[]',item.file);
                            flag+=1;
                        })
                        if(flag>=4) {
                            this.axios.post(url2+'upload',(formData),{
                                headers: {  'Content-Type': 'multipart/form-data;' }
                            }).then(res=> {
                                if(res.data.code==1) {
                                    this.sure2(res.data.data)
                                }  else {
                                    this.loading.close();
                                }
                            }).catch(err=> {
                                this.loading.close();
                                console.log(err);
                            });
                        }
                    }
                } else {
                    this.$dialog.alert({
                        title: '提示',
                        message: '无法提交，时间不对',
                    }).then(() => {
                        return;
                    });
                }
            },
            sure2(photo) {
                this.axios.get(url2+'subList', {
                    params:{
                        zhuchang: this.list.zhuchang,
                        type: this.list.type,
                        danwei: this.list.danwei,
                        chepai: this.list.chepai,
                        number: this.list.number,
                        tel: this.list.tel,
                        name: this.list.name,
                        info1:this.flow1,
                        info2:this.flow2,
                        info3:this.flow3,
                        info4:this.flow4,
                        now:this.now1,
                        beizhu:this.beizhu,
                        time:this.time,
                        url:photo.toString()
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.fileList = []
                            this.flow1 = ''
                            this.flow2 = ''
                            this.flow3 = ''
                            this.weight1 = ''          
                            this.weight2 = ''
                            this.beizhu = ''
                            this.time = ''  
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .menu main {
        font-size: 14px;
        padding: 40px 16px 28px 16px;
        background-color: #FFDCA3;
    }
    .menu .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .menu h2 {
        text-align: center;
        margin-bottom: 20px;
    }
   
    .menu /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
    .menu h4 {
        text-indent: 16px;
    }
    .menu /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }
</style>
